import { SurveyQuestion } from "./models/survey";

export class Answer {

    /**
     * Examines the data of the click checkbox event and maps the event to either a 
     * Checked or Unchecked.
     * @param $event
     * @returns CheckboxAction enum.
     */
    static getActionType($event: any): CheckboxAction { // write test
        if ($event.detail.checked) {
            return CheckboxAction.Checked;
        }
        else {
            return CheckboxAction.Unchecked;
        }
    }

    /**
     * Examines the data of the click event (radio or checkbox) and maps the value 
     * of the box to either Other, Decline, or AnythingElse.
     * @param $event 
     * @returns AnswerValueType enum.
     */
    static getValueType($event: any): AnswerValueType { // write test
        if ($event.detail.value.toLowerCase() === "other") {
            return AnswerValueType.Other;
        }
        else if ($event.detail.value.toLowerCase() === "prefer not to answer") {
            return AnswerValueType.Decline;
        }
        else {
            return AnswerValueType.AnythingElse;
        }
    }

    /**
     * Updates the boolean array at the provided index to true. The UI is bound to the 
     * checkboxes array, so setting this equal to true allows the box to be checked.
     * @param question question id.
     * @param index index of the option in the original list of choices array.
     */
    static check(question: SurveyQuestion, index: number) {
        question.previous.checkboxes[index!] = true;
    }

    /**
     * Updates the boolean array at the provided index to false. The UI is bound to the 
     * checkboxes array, so setting this equal to false unchecks the box.
     * @param question question id.
     * @param index index of the option in the original list of choices array.
     */
    static uncheck(question: SurveyQuestion, index: number) {
        question.previous.checkboxes[index!] = false;
    }
}

export enum CheckboxAction {
    Checked,
    Unchecked,
}

export enum AnswerValueType {
    Other = "other",
    Decline = "prefer not to answer",
    AnythingElse = ""
}

export class AnswerObj {

    answer: string; // for questions where only one choice is acceptable, otherwise will be empty
    answers: string[]; // for questions where multiple choices are acceptable, otherwise will be empty
    other: string; // for questions where 'Other' option is allowed

    constructor() {
        this.answer = "";
        this.answers = [];
        this.other = "";
    }

    /**
     * Reset all properties of the AnswerObj.
     */
    reset() {
        this.answer = "";
        this.answers = [];
        this.other = "";
    }

}